export default function checkNull(prop) {
  if (prop === null || prop === undefined) {
    return 'n/a';
  } else {
    return prop;
  }
}
